import { Delete, Edit } from '@mui/icons-material';
import { Box, Divider, IconButton, Link } from '@mui/material';

import { spaces } from '../../../../assets/styles/themes/tokens';

export type LinkPreviewPanelProps = {
	url: string;
	onEdit: () => void;
	onClear: () => void;
};

const LinkPreviewPanel = ({ onClear, onEdit, url }: LinkPreviewPanelProps) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				gap: spaces.xxs,
				alignItems: 'center',
			}}
			data-testid="link-preview-panel"
		>
			<Link href={url} target="_blank" rel="noopener noreferrer">
				{url}
			</Link>
			<Divider orientation="vertical" flexItem />
			<IconButton size="small" onClick={onEdit} data-testid="edit-link-button">
				<Edit />
			</IconButton>
			<IconButton size="small" onClick={onClear} data-testid="clear-link-button">
				<Delete />
			</IconButton>
		</Box>
	);
};

export default LinkPreviewPanel;
